import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ClientDealTermResponse } from '@interfaces/partners/responses/client-deal.response';
import { VaultDateTimePipe } from '@src/app/shared/pipes/vault-date-time.pipe';
import { SharedModule } from '@src/app/shared/shared.module';
import { clientTermSignatureState } from '../../client-deal-stage';

/**
 * Card "Assinaturas" da Visão do Cliente (card 3461).
 *
 * O NDA de confidencialidade e a carta de autorização SCR são **um documento só** no provedor de
 * assinatura (`CommercialClientTerm`), com um link por assinante. Por isso o card mostra uma linha
 * para o termo, e não duas linhas com dois botões que abririam o mesmo link (o protótipo desenha
 * duas). "Assinar agora" aparece só para o assinante logado que ainda não assinou.
 *
 * Só desenha: quem pede o link e abre a aba é a página (`sign`).
 */
@Component({
  selector: 'app-client-signatures-card',
  standalone: true,
  imports: [SharedModule, VaultDateTimePipe],
  templateUrl: './client-signatures-card.component.html',
  styleUrl: './client-signatures-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientSignaturesCardComponent {
  /** NDA + carta SCR da empresa; nulo enquanto a Legatus não gerou o termo. */
  readonly term = input<ClientDealTermResponse | null>(null);

  /** O link de assinatura está sendo buscado (o botão mostra o carregamento). */
  readonly signing = input(false);

  /** A aba de assinatura já foi aberta nesta visita: mostra a dica de Atualizar. */
  readonly signLinkOpened = input(false);

  /** Pede à página o link de assinatura do usuário logado. */
  readonly sign = output<void>();

  /** Pede à página para recarregar a operação (depois de assinar na outra aba). */
  readonly refresh = output<void>();

  protected readonly state = computed(() => clientTermSignatureState(this.term()));

  protected readonly signatories = computed(() => this.term()?.signatories ?? []);
}
